/**
 * Constantes e funções utilitárias para validação do cliente PFIZER
 *
 * Este arquivo segue o mesmo padrão de implementação do abbottClient.ts /
 * eliLillyClient.ts para manter consistência no código, mas usa
 * correspondência por substring (em vez de lista exata de razões sociais),
 * pois é assim que o check de Pfizer já era feito em ProjectEvent.tsx.
 */

/**
 * Normaliza o nome do cliente para comparação.
 *
 * Remove espaços extras, converte para maiúsculas e garante
 * que o valor seja sempre uma string válida.
 *
 * @param name - Nome do cliente (pode ser null ou undefined)
 * @returns Nome normalizado em maiúsculas
 */
export function normalizeClientNameForPfizer(name?: string | null): string {
  return String(name ?? "")
    .trim()
    .toUpperCase();
}

/**
 * Verifica se o cliente selecionado é PFIZER.
 *
 * @param clientName - Nome do cliente a ser validado
 * @returns true se o nome do cliente contiver "PFIZER", false caso contrário
 *
 * @example
 * isPfizerClient("PFIZER") // true
 * isPfizerClient("Pfizer Brasil") // true
 * isPfizerClient("Outro Cliente") // false
 */
export function isPfizerClient(clientName?: string | null): boolean {
  const normalized = normalizeClientNameForPfizer(clientName);
  if (!normalized) return false;
  return normalized.includes("PFIZER");
}
